import useTableDetails from '../hooks/useTableDetails';
import EditorDetails from 'components/details/EditorDetails';

const Editor = () => {
    const { items, error, loading } = useTableDetails();

    return (
        <EditorDetails
            hideDescription={true}
            loading={loading}
            error={error}
            items={items}
            type="dataset"
        />
    );
};

export default Editor;
